import React from 'react';
import './style.css'
import EventForm from './Form';

const EventPage = ({ event_id }) => {
    return (
        <div id="Contact" className="contact-area">
            <div className="container">
                <div className="contact-content">
                    <h2 style={{ fontSize: '26px', marginBottom: '26px' }}>{event_id !== "false" ? "Update" : "Add"} Event Information</h2>
                    <div className="contact-form">
                        <EventForm event_id={event_id} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventPage;